import styled from 'styled-components'
import { tokens } from 'styling/tokens'
import { IStyledCard } from 'types/ui/card.interface'

export const StyledCard = styled.div<IStyledCard>`
  background: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  padding: ${tokens.space.md};

  ${({ $glow }) =>
    $glow &&
    `background: radial-gradient(130% 130% at 0% 0%, ${tokens.accent.glowTint}, ${tokens.surface.glass} 58%);
     border-color: ${tokens.accent.glowBorder};
     box-shadow: ${tokens.accent.glow};`}
`
